import { render, staticRenderFns } from "./SeveralManagement.vue?vue&type=template&id=7567b731&scoped=true"
import script from "./SeveralManagement.vue?vue&type=script&lang=js"
export * from "./SeveralManagement.vue?vue&type=script&lang=js"
import style0 from "./SeveralManagement.vue?vue&type=style&index=0&id=7567b731&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7567b731",
  null
  
)

export default component.exports